/* esm.sh - ts-easing@0.2.0 */
export * from "/*ts-easing@0.2.0/esnext/ts-easing.mjs";
export { default } from "/*ts-easing@0.2.0/esnext/ts-easing.mjs";
